/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".change-password[_ngcontent-%COMP%]{font-size:18px!important}.change-password[_ngcontent-%COMP%]::before{font-size:15px;float:left;margin-right:8px}"];
export { styles as styles };
